export default {
  firstMonth: {
    en: '<span class="bold">{discountPrice}</span> <span class="crossedPrice">{price}</span>/First month',
  },
}
